import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "./Http";
import { getAppThemeName } from "../services/appTheme";
export let availableLanguages = getAppThemeName() === "inkassier"
    ? {
        nl: {
            image: "/assets/img/layout/flags/netherlands.png",
            label: "Nederlands",
        },
        en: {
            image: "/assets/img/layout/flags/uk.png",
            label: "English",
        },
    }
    : {
        nl: {
            image: "/assets/img/layout/flags/netherlands.png",
            label: "Nederlands",
        },
        en: {
            image: "/assets/img/layout/flags/uk.png",
            label: "English",
        },
        // tr: {
        //   image: "/assets/img/layout/flags/turkey.png",
        //   label: "Türkler"
        // },
        // ar: {
        //   image: "/assets/img/layout/flags/morocco.png",
        //   label: "مغربي"
        // },
        // pl: {
        //   image: "/assets/img/layout/flags/poland.png",
        //   label: "Polskie"
        // }
    };
export const languageDetector = new LanguageDetector(null, {
    order: ["sessionStorage", "localStorage", "querystring", "navigator"],
    caches: [],
});
export const getActiveLanguage = () => availableLanguages[i18n.language || "nl"];
export const setActiveLanguage = (language) => {
    axios.defaults.headers.common["Accept-Language"] = language;
    languageDetector.cacheUserLanguage(language, [
        "localStorage",
        "sessionStorage",
    ]);
    return i18n.changeLanguage(language);
};
/**
 * Copied from languageDetector.services.languageUtils, but without returning fallback
 * @param codes
 */
export const getBestMatchFromCodesWithoutFallback = (codes) => {
    if (!codes) {
        return null;
    }
    const baseUtil = languageDetector.services.languageUtils;
    let found = null;
    // pick first supported code or if no restriction pick the first one (highest prio)
    codes.forEach(code => {
        if (found) {
            return;
        }
        let cleanedLng = baseUtil.formatLanguageCode(code);
        if (!baseUtil.options.supportedLngs ||
            baseUtil.isSupportedCode(cleanedLng)) {
            found = cleanedLng;
        }
    });
    // if we got no match in supportedLngs yet - check for similar locales
    // first  de-CH --> de
    // second de-CH --> de-DE
    if (!found && baseUtil.options.supportedLngs) {
        codes.forEach(code => {
            if (found) {
                return;
            }
            let lngOnly = baseUtil.getLanguagePartFromCode(code);
            if (baseUtil.isSupportedCode(lngOnly)) {
                return (found = lngOnly);
            }
            found = baseUtil.options.supportedLngs.find((supportedLng) => {
                if (supportedLng.indexOf(lngOnly) === 0) {
                    return supportedLng;
                }
            });
        });
    }
    return found;
};
export const getLocale = () => {
    const lang = i18n.language;
    if (lang === "nl") {
        return "nl-nl";
    }
    return "en-gb";
};
export default i18n;
